const normalizeString = (value = '') => String(value || '').trim();

const toTimestamp = (value) => {
  if (!value) return 0;
  const ts = new Date(value).getTime();
  return Number.isFinite(ts) ? ts : 0;
};

const firstPresentNumber = (item, keys = []) => {
  for (const key of keys) {
    const value = item?.[key];
    if (typeof value === 'number' && Number.isFinite(value)) return value;
  }
  return null;
};

const compareByNameAsc = (a, b) => {
  const nameA = normalizeString(a?.name || a?.title || '');
  const nameB = normalizeString(b?.name || b?.title || '');
  const byName = nameA.localeCompare(nameB);
  if (byName !== 0) return byName;

  const idA = Number(a?.id ?? 0);
  const idB = Number(b?.id ?? 0);
  return idA - idB;
};

const compareByRecentDesc = (a, b, dateKeys = ['updated_at', 'created_at']) => {
  const getDate = (item) => {
    for (const key of dateKeys) {
      const ts = toTimestamp(item?.[key]);
      if (ts > 0) return ts;
    }
    return 0;
  };

  const byDate = getDate(b) - getDate(a);
  if (byDate !== 0) return byDate;
  return compareByNameAsc(a, b);
};

const compareByManualAsc = (a, b, manualKeys = ['sort_index', 'manual_order', 'position', 'order']) => {
  const posA = firstPresentNumber(a, manualKeys);
  const posB = firstPresentNumber(b, manualKeys);

  if (posA != null && posB != null && posA !== posB) {
    return posA - posB;
  }
  if (posA != null && posB == null) return -1;
  if (posA == null && posB != null) return 1;

  return compareByNameAsc(a, b);
};

export const createItemComparator = (
  mode = 'alphabetical',
  {
    dateKeys = ['updated_at', 'created_at'],
    manualKeys = ['sort_index', 'manual_order', 'position', 'order']
  } = {}
) => {
  switch (String(mode || '').toLowerCase()) {
    case 'recent':
      return (a, b) => compareByRecentDesc(a, b, dateKeys);
    case 'manual':
      return (a, b) => compareByManualAsc(a, b, manualKeys);
    case 'alphabetical':
    default:
      return compareByNameAsc;
  }
};

export const sortItemsByMode = (items = [], mode = 'alphabetical', options = {}) => {
  const comparator = createItemComparator(mode, options);
  return [...(Array.isArray(items) ? items : [])].sort(comparator);
};
